import * as z from 'zod';
import { StoreRegion } from '~/graphql/graphql.gen';

export const marketingQueryParamsSchema = z.object({
  edit: z.boolean().optional(),
  immersiveId: z.string().optional(),
  region: z.enum([StoreRegion.Fr, StoreRegion.Us]).catch(StoreRegion.Fr),
});

export type MarketingQueryParams = z.infer<typeof marketingQueryParamsSchema>;
